import React from 'react';

import {Link} from 'react-router';

import {getPolicyName} from 'app/utils/fallbacks';
import {gt} from 'app/utils/i18n';

import type {NestedPolicyProcedureSerializedType} from 'sweet-types';
type Props = {
  policies?: Array<NestedPolicyProcedureSerializedType>;
};
export const DocumentPolicyList = ({policies}: Props): JSX.Element | null =>
  policies != null && policies.length ? (
    <div>
      <span className="small">{gt('Related policies')}</span>
      <ul className="list-inline">
        {policies.map((policy) => (
          <li className="d-block d-sm-inline-block mr-sm-1" key={policy.url}>
            <Link
              className="btn btn-outline-secondary btn-sm mb-1 d-block d-sm-inline-block text-left"
              to={policy.html_url}
            >
              {getPolicyName(policy.name)}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  ) : null;
